import Button from 'components/Form/Button';
import UploadFileStage from 'components/Form/UploadFileStage';
import { CoreContext } from 'context/CoreContext';
import { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { PUT, UploadImage } from 'services/api';
import { Update } from 'services/banking';
import { Title } from 'ui/styled';
import FormCore from '../../Form/Core';
import Wrapper from '../Wrapper';
import {
  AddProposalContainer,
  BotaoDocumento,
  BotaoDocumentoObrigatorio,
  CompanyButtonContainer,
} from './styled';

export default function BankingDocumentos({ dados, reload }) {
  const includeAvalistaCheckbox =
    dados?.observationCheckList?.includes('incluir_avalista');

  const requestRendaCheckbox =
    dados?.observationCheckList?.includes('solicitar_renda');

  const { setModal } = useContext(CoreContext);
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [avalista, setAvalista] = useState(includeAvalistaCheckbox);
  const [clientIdent, setClientIdent] = useState(null);
  const [clientRenda, setClientRenda] = useState(null);
  const [avalIdent, setAvalIdent] = useState(null);
  const [avalRenda, setAvalRenda] = useState(null);

  const close = () => setModal(null);

  useEffect(() => {
    if (!dados) {
      return;
    }
    const docIdent = Array.isArray(dados.cliente?.documento_identificacao)
      ? dados.cliente.documento_identificacao[0]
      : dados.cliente?.documento_identificacao;
    const docRenda = Array.isArray(dados.cliente?.comprovante_renda)
      ? dados.cliente.comprovante_renda[0]
      : dados.cliente?.comprovante_renda;
    if (docIdent) {
      setClientIdent(docIdent);
    }
    if (docRenda) {
      setClientRenda(docRenda);
    }
    if (dados.avalista_nome || dados.avalista_cpf) {
      setAvalista(true);
      const docIdentAval = Array.isArray(dados.avalista_doc_ident)
        ? dados.avalista_doc_ident[0]
        : dados.avalista_doc_ident;
      const docRendaAval = Array.isArray(dados.avalista_comp_renda)
        ? dados.avalista_comp_renda[0]
        : dados.avalista_comp_renda;
      if (docIdentAval) setAvalIdent(docIdentAval ?? includeAvalistaCheckbox);
      if (docRendaAval) {
        setAvalRenda(docRendaAval);
      }
      setTimeout(() => {
        if (formRef.current?.setItem) {
          formRef.current.setItem(dados.avalista_nome || '', 'avalista_nome');
          formRef.current.setItem(dados.avalista_cpf || '', 'avalista_cpf');
          formRef.current.setItem(
            dados.avalista_telefone || '',
            'avalista_telefone'
          );
          formRef.current.setItem(
            dados.avalista_bureau_score || '',
            'avalista_bureau_score'
          );
        }
      }, 1000);
    }
  }, [dados, includeAvalistaCheckbox]);

  const formCrivo = [
    {
      ref: 'avalista_nome',
      placeholder: 'Nome Avalista',
      type: 'string',
      required: true,
      disabled: false,
      half: true,
    },
    {
      ref: 'avalista_cpf',
      placeholder: 'CPF Avalista',
      type: 'cpf',
      required: true,
      disabled: false,
      half: true,
    },
    {
      ref: 'avalista_telefone',
      placeholder: 'Telefone Avalista',
      mask: '(99)99999-9999',
      required: true,
      disabled: false,
      half: true,
    },
    {
      ref: 'avalista_bureau_score',
      placeholder: 'Score Avalista',
      type: 'string',
      required: false,
      disabled: false,
      half: true,
    },
  ];
  const save = async () => {
    try {
      setLoading(true);
      const resClientIdent =
        clientIdent instanceof File ? await UploadImage(clientIdent) : null;
      const resClientRenda =
        clientRenda instanceof File ? await UploadImage(clientRenda) : null;
      const resAvalIdent =
        avalIdent instanceof File ? await UploadImage(avalIdent) : null;
      const resAvalRenda =
        avalRenda instanceof File ? await UploadImage(avalRenda) : null;
      if (clientIdent === null) {
        toast.error('Documento de identificação do cliente é obrigatório.');
        return;
      }
      const clientDocsPayload = {
        documento_identificacao: resClientIdent
          ? resClientIdent[0].id
          : clientIdent?.id || null,
        comprovante_renda: resClientRenda
          ? resClientRenda[0].id
          : clientRenda?.id || null,
      };

      if (requestRendaCheckbox && !clientDocsPayload.comprovante_renda) {
        toast.error('Comprovante de renda é obrigatório.');
        return;
      }

      await PUT(`/clients/${dados.cliente.id}`, clientDocsPayload, true);

      if (avalista) {
        if (avalIdent === null) {
          toast.error('Documento de identificação do Avalista é obrigatório.');
          return;
        }
        const form = await formRef.current.getForm?.();
        if (!form) {
          return;
        }
        const payload = {
          status: 'aprovar',
          avalista_nome: form.avalista_nome,
          avalista_cpf: form.avalista_cpf,
          avalista_telefone: form.avalista_telefone,
          avalista_bureau_score: form.avalista_bureau_score,
          avalista_doc_ident: resAvalIdent
            ? resAvalIdent[0].id
            : avalIdent?.id || null,
          avalista_comp_renda: resAvalRenda
            ? resAvalRenda[0].id
            : avalRenda?.id || null,
        };

        const result = await Update({ data: payload }, dados.id);
        if (result.status !== 200) {
          throw new Error('Erro ao salvar proposta');
        }
      } else {
        await Update({ data: { status: 'aprovar' } }, dados.id);
      }
      toast.success('Registro salvo com sucesso!', {
        onClose: () => reload?.(),
      });
      close();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };
  if (!dados) return null;

  return (
    <Wrapper title="Documentação">
      <Title nomargin small>
        Documentos Cliente
      </Title>
      <AddProposalContainer>
        <UploadFileStage
          onChange={(file) => setClientIdent(file)}
          proposalType="A_Formalizar"
        >
          <BotaoDocumentoObrigatorio>
            {clientIdent
              ? `Selecionado: ${clientIdent.name}`
              : 'Documento de Identificação *'}
          </BotaoDocumentoObrigatorio>
        </UploadFileStage>
        <UploadFileStage
          onChange={(file) => setClientRenda(file)}
          proposalType="A_Formalizar"
        >
          {requestRendaCheckbox ? (
            <BotaoDocumentoObrigatorio>
              {clientRenda
                ? `Selecionado: ${clientRenda.name}`
                : 'Comprovante de Renda *'}
            </BotaoDocumentoObrigatorio>
          ) : (
            <BotaoDocumento>
              {clientRenda
                ? `Selecionado: ${clientRenda.name}`
                : 'Comprovante de Renda'}
            </BotaoDocumento>
          )}
        </UploadFileStage>
      </AddProposalContainer>
      {!avalista ? (
        <AddProposalContainer>
          <Button
            color="lightgrey"
            border
            onClick={() => setAvalista(!avalista)}
            nospace
          >
            Incluir Avalista
          </Button>
        </AddProposalContainer>
      ) : (
        <>
          <Title nomargin small="true">
            Documentos Avalista
          </Title>
          <AddProposalContainer>
            <FormCore ref={formRef} formItems={formCrivo} />
            <UploadFileStage
              onChange={(file) => setAvalIdent(file)}
              proposalType="A_Formalizar"
            >
              <BotaoDocumentoObrigatorio>
                {avalIdent
                  ? `Selecionado: ${avalIdent.name}`
                  : 'Documento de Identificação *'}
              </BotaoDocumentoObrigatorio>
            </UploadFileStage>
            <UploadFileStage
              onChange={(file) => setAvalRenda(file)}
              proposalType="A_Formalizar"
            >
              <BotaoDocumento>
                {avalRenda
                  ? `Selecionado: ${avalRenda.name}`
                  : 'Comprovante de Renda'}
              </BotaoDocumento>
            </UploadFileStage>
          </AddProposalContainer>
        </>
      )}
      <CompanyButtonContainer>
        <Button color="lightgrey" onClick={close} border nospace>
          Cancelar
        </Button>
        <Button color="blue" loading={loading} onClick={save} nospace>
          Salvar Alterações
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  );
}
